// extracted by mini-css-extract-plugin
module.exports = {"control":"Control_control__KpL1A","button":"Control_button__ZFW3w"};